module.exports = __webpack_public_path__ + "img/pro-img-03.52a386ee.png";